// @flow
import React, { useCallback } from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import TextField from 'material-ui/TextField';
import { sectionPath } from '../../../lib/config';
import ArticleSelector from '../../articles/ArticleSelector';
import Checkbox from 'material-ui/Checkbox';

export const ArticleListBlock = props => {
	const { control, register } = props;

	const { fields, append, remove } = useFieldArray({
		control,
		name: 'config.linked',
	});

	const provideItem = useCallback((t, index) => {
		console.log(t);
		return (
			<div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
				<div style={{ width: 400 }}>
					<a href={`/articles/${sectionPath.news}/${t.id}`} className="pseudo-link">
						<small>{t.title}</small>
					</a>
				</div>
				<input type="hidden" {...register(`config.linked.${index}.id`)} defaultValue={t.id} />
				<Controller
					name={`config.linked.${index}.customTitle`}
					control={control}
					render={({ field: { onChange, value } }) => (
						<TextField value={value} onChange={onChange} floatingLabelText="Заголовок" fullWidth floatingLabelFixed={true} />
					)}
				/>
			</div>
		);
	}, []);

	return (
		<React.Fragment>
			<Controller
				name="config.nearestNews"
				control={control}
				defaultValue={false}
				render={({ field: { onChange, value } }) => <Checkbox label="Отображать одну ближайшую новость" onCheck={onChange} checked={value} />}
			/>
			<Controller
				name="config.title"
				control={control}
				rules={{ required: true }}
				render={({ fieldState: { error }, field: { onChange, value } }) => (
					<TextField
						value={value}
						errorText={error ? 'Название рекламного блока обязательно для заполнения' : ''}
						onChange={onChange}
						floatingLabelText="Название рекламного блока"
						fullWidth
						floatingLabelFixed={true}
					/>
				)}
			/>
			<ArticleSelector
				limit={1}
				section={sectionPath.news}
				floatingLabelFixed
				itemProvider={provideItem}
				onAdd={append}
				onRemove={remove}
				placeholder="Начните ввод"
				hint="Добавленные статьи"
				viewer={props.viewer}
				value={fields}
				disabled={false}
			/>
		</React.Fragment>
	);
};



// WEBPACK FOOTER //
// src/components/configurable-blocks/parts/ArticleListBlock.jsx